export default "__VITE_ASSET__DI1w3UCW__"